module.exports = __webpack_public_path__ + "static/media/CSK-horiz-tablet-hover@2x.ecd82695.png";